import { useContext, useEffect } from 'react';
import { UserContext } from './context/UserContext';
import ForestDataHubHeader from './components/header/Header';
import ForestDataMap from './map/ForestDataMap';
import DataCatalogNew from './data/DataCatalogNew';
// import AddEditDataPage from './data/AddEditPage/AddEditDataPage';
import DataCollectionPage from './data/DataCollection/DataCollectionPage';
// import DraftDataPage from './data/DraftData/DraftDataPage';
import { Route, Routes } from 'react-router-dom';
import Home from './home';
import ErrorPage from './ErrorPage';
import VerifyAccount from './VerifyAccount';
import DatasetPage from './data/DatasetPage';
import CKAN from './lib/CKAN';
import DocumentationRoute from './documentation/DocumentationRoute';
import WorkspaceContext from './context/WorkspaceContext';
import PublishedWorkspacesPage from './data/PublishedWorkspaces/PublishedWorkspacesPage';
import AboutPage from './data/About/AboutPage';

const AppRoutes = (props) => {
  const {
    getGisService,
    getItemKey,
    filtersDatasets,
    setFilterDatasets,
    checkedDatasets,
    setCheckedDatasets,
    filterItems,
    setFilterItems,
    opacities,
    setOpacities,
    layerColors,
    setLayerColors,
    valueRanges,
    setValueRanges,
    // addDataType,
    setAddDataType,
    layersByUser,
    setLayersByUser,
    clipLayer,
    setClipLayer,
    selectedClipBoundary,
    setSelectedClipBoundary,
    selectedClipSubset,
    setSelectedClipSubset,
    selectedCustomClipKey,
    setSelectedCustomClipKey,
    clipEnabled,
    setClipEnabled,
    highlightClip,
    setHighlightClip,
  } = props;
  const { user } = useContext(UserContext);
  const { selectedDatasets, setSelectedDatasets } =
    useContext(WorkspaceContext);
  useEffect(() => {
    const fetchData = async () => {
      // CLM boundary data
      const defaultData = [
        'fdh-california-county-boundaries',
        // 'its-interagency-treatment-dashboard-activity-report-version-111',
      ];

      const foundData = await defaultData.map(async (data) => {
        let dataset = await CKAN.getSpecificDatasetByName(data);
        if (dataset?.status) return null;
        if (dataset.length == 1) {
          return dataset[0];
        }
      });
      const results = await Promise.all(foundData);
      // Removes datasets if nothing was returned
      const trimmed = results.filter((dataset) => dataset);
      setSelectedDatasets(trimmed);
    };
    if (selectedDatasets.length === 0) {
      fetchData();
    }
  }, [user]);
  return (
    <div style={{ display: 'flex', minHeight: '100%' }}>
      <Routes>
        {/* {Object.keys(user).length === 0 || user?.access_token == undefined ? (
        <>
          <Route
            path="/"
            element={
              <>
                <ForestDataHubHeader />
                <div style={{ paddingTop: '50px', height: '100%' }}>
                  <Home signedIn={false} />
                </div>
              </>
            }
          />
          <Route
            path="/workspace"
            element={
              <>
                <ForestDataHubHeader
                  getGisService={getGisService}
                  getItemKey={getItemKey}
                  setFilterItems={setFilterItems}
                  setCheckedDatasets={setCheckedDatasets}
                  opacities={opacities}
                  setOpacities={setOpacities}
                />
                <div style={{ paddingTop: '50px', height: '100%' }}>
                  <ForestDataMap
                    selectedDatasets={selectedDatasets}
                    layerColors={layerColors}
                    setLayerColors={setLayerColors}
                    valueRanges={valueRanges}
                    setValueRanges={setValueRanges}
                    checkedDatasets={checkedDatasets}
                    setCheckedDatasets={setCheckedDatasets}
                    filtersDatasets={filtersDatasets}
                    setFilterDatasets={setFilterDatasets}
                    getGisService={getGisService}
                    getItemKey={getItemKey}
                    filterItems={filterItems}
                    setFilterItems={setFilterItems}
                    opacities={opacities}
                    setOpacities={setOpacities}
                    layersByUser={layersByUser}
                    setLayersByUser={setLayersByUser}
                    clipLayer={clipLayer}
                    setClipLayer={setClipLayer}
                    selectedClipBoundary={selectedClipBoundary}
                    setSelectedClipBoundary={setSelectedClipBoundary}
                    selectedClipSubset={selectedClipSubset}
                    setSelectedClipSubset={setSelectedClipSubset}
                    selectedCustomClipKey={selectedCustomClipKey}
                    setSelectedCustomClipKey={setSelectedCustomClipKey}
                    clipEnabled={clipEnabled}
                    setClipEnabled={setClipEnabled}
                    highlightClip={highlightClip}
                    setHighlightClip={setHighlightClip}
                  />
                </div>
              </>
            }
          />
          <Route
            path="/catalog"
            element={
              <>
                <ForestDataHubHeader
                  getGisService={getGisService}
                  getItemKey={getItemKey}
                  setFilterItems={setFilterItems}
                  setCheckedDatasets={setCheckedDatasets}
                  opacities={opacities}
                  setOpacities={setOpacities}
                />
                <div style={{ paddingTop: '50px', height: '100%' }}>
                  <DataCatalogNew
                    user={user}
                    getGisService={getGisService}
                    setAddDataType={setAddDataType}
                    filterItems={filterItems}
                    setFilterItems={setFilterItems}
                    getItemKey={getItemKey}
                  />
                </div>
              </>
            }
          />{' '}
          <Route
            path="/data_collection"
            element={
              <>
                <ForestDataHubHeader
                  getGisService={getGisService}
                  getItemKey={getItemKey}
                  setFilterItems={setFilterItems}
                  setCheckedDatasets={setCheckedDatasets}
                  opacities={opacities}
                  setOpacities={setOpacities}
                />
                <div style={{ paddingTop: '50px', height: '100%' }}>
                  <DataCollectionPage />
                </div>
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                <ForestDataHubHeader />
                <div style={{ paddingTop: '50px', height: '100%' }}>
                  <ErrorPage />
                </div>
              </>
            }
          />
          {DocumentationRoute}
        </>
      ) : ( */}
        <>
          <Route
            path="/"
            element={
              <>
                <ForestDataHubHeader>
                  <Home signedIn={true} />
                </ForestDataHubHeader>
              </>
            }
          ></Route>
          <Route
            path="/mapviewer"
            element={
              <>
                <ForestDataHubHeader>
                  <ForestDataMap
                    selectedDatasets={selectedDatasets}
                    layerColors={layerColors}
                    setLayerColors={setLayerColors}
                    valueRanges={valueRanges}
                    setValueRanges={setValueRanges}
                    checkedDatasets={checkedDatasets}
                    setCheckedDatasets={setCheckedDatasets}
                    filtersDatasets={filtersDatasets}
                    setFilterDatasets={setFilterDatasets}
                    getGisService={getGisService}
                    getItemKey={getItemKey}
                    filterItems={filterItems}
                    setFilterItems={setFilterItems}
                    opacities={opacities}
                    setOpacities={setOpacities}
                    layersByUser={layersByUser}
                    setLayersByUser={setLayersByUser}
                    clipLayer={clipLayer}
                    setClipLayer={setClipLayer}
                    selectedClipBoundary={selectedClipBoundary}
                    setSelectedClipBoundary={setSelectedClipBoundary}
                    selectedClipSubset={selectedClipSubset}
                    setSelectedClipSubset={setSelectedClipSubset}
                    selectedCustomClipKey={selectedCustomClipKey}
                    setSelectedCustomClipKey={setSelectedCustomClipKey}
                    clipEnabled={clipEnabled}
                    setClipEnabled={setClipEnabled}
                    highlightClip={highlightClip}
                    setHighlightClip={setHighlightClip}
                  />
                </ForestDataHubHeader>
              </>
            }
          />
          <Route
            path="/catalog"
            element={
              <>
                <ForestDataHubHeader>
                  <DataCatalogNew
                    user={user}
                    getGisService={getGisService}
                    setAddDataType={setAddDataType}
                    filterItems={filterItems}
                    setFilterItems={setFilterItems}
                    getItemKey={getItemKey}
                  />
                </ForestDataHubHeader>
              </>
            }
          />
          {/* <Route
          path="/catalog/new"
          element={
            <>
              <ForestDataHubHeader
                getGisService={getGisService}
                getItemKey={getItemKey}
                setFilterItems={setFilterItems}
                setCheckedDatasets={setCheckedDatasets}
                opacities={opacities}
                setOpacities={setOpacities}
              />
              <div style={{ paddingTop: '50px', height: '100%' }}>
                <AddEditDataPage
                  addDataType={addDataType}
                  user={user}
                  getGisService={getGisService}
                />
              </div>
            </>
          }
        /> */}
          <Route
            path="/data_collection"
            element={
              <>
                <ForestDataHubHeader>
                  <DataCollectionPage />
                </ForestDataHubHeader>
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <ForestDataHubHeader>
                  <AboutPage />
                </ForestDataHubHeader>
              </>
            }
          />
          {/* <Route
            path="/data_collection/its"
            element={
              <>
                <ForestDataHubHeader>
                  <DataCollectionIframe display={'its'} />
                </ForestDataHubHeader>
              </>
            }
          />
          <Route
            path="/data_collection/clm"
            element={
              <>
                <ForestDataHubHeader>
                  <DataCollectionIframe display={'clm'} />
                </ForestDataHubHeader>
              </>
            }
          /> */}
          <Route
            path="/workspace"
            element={
              <>
                <ForestDataHubHeader>
                  <PublishedWorkspacesPage />
                </ForestDataHubHeader>
              </>
            }
          />
          {/* <Route
          path="/drafts"
          element={
            <>
              <ForestDataHubHeader
                getGisService={getGisService}
                getItemKey={getItemKey}
                setFilterItems={setFilterItems}
                setCheckedDatasets={setCheckedDatasets}
                opacities={opacities}
                setOpacities={setOpacities}
              />
              <div style={{ paddingTop: '50px', height: '100%' }}>
                <DraftDataPage user={user} />
              </div>
            </>
          }
        /> */}
          {DocumentationRoute}
          <Route
            path="/catalog/:datasetName"
            element={
              <>
                <ForestDataHubHeader>
                  <DatasetPage getGisService={getGisService} />
                </ForestDataHubHeader>
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                <ForestDataHubHeader>
                  <ErrorPage />
                </ForestDataHubHeader>
              </>
            }
          />
        </>
        {/* )} */}
        <Route
          path="/Auth/validate_account/:username/:access_token"
          exact
          element={<VerifyAccount />}
        ></Route>
      </Routes>
    </div>
  );
};
export default AppRoutes;
